// <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="lucide lucide-circle-chevrons-down">
// <circle cx="12" cy="12" r="10"/>
// <path d="m9 8  3 3 3-3"/>
// <path d="m9 14 3 3 3-3"/>
// </svg>

import { LucideIconData } from 'lucide-angular';

export const CircleChevronsDown: LucideIconData = [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
    },
  ],
  [
    'path',
    {
      d: 'm9,8 3,3 3,-3',
    },
  ],
  [
    'path',
    {
      d: 'm9,14 3,3 3,-3',
    },
  ],
];
